'use client';

import { useRef } from 'react';
import { useHubspotForm } from 'next-hubspot';
import useScrollToElement from 'helpers/hooks/useScrollToElement';
import { TasticProps } from '../types';

interface HubspotFormProps {
  formId: string;
  heading: string;
  subheading?: string;
}

const HubspotFormTastic = ({ data }: TasticProps<HubspotFormProps>) => {
  const formRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const formDivId = `hubspot-form-wrapper-${data.formId}`;

  const { scrollToElement } = useScrollToElement(containerRef);

  const { isScriptLoaded, isScriptError, isFormCreated } = useHubspotForm({
    portalId: process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID ?? '',
    css: ``, // Needed so it uses styles defined in styles/components/hubspot-form.css
    formId: data.formId,
    target: `#${formDivId}`,
    onFormSubmitted() {
      // Scroll to component after form submission with header offset
      scrollToElement(200);
    },
  });

  if (isScriptLoaded && (isScriptError || !isFormCreated)) return;

  return (
    <div className="bg-secondary pb-32 pt-40 lg:pb-64 lg:pt-72" ref={containerRef}>
      <div className="container mb-32">
        <h2 className="body-text-2xlarge">{data.heading}</h2>
        {data.subheading && <h3 className="mt-16 font-poppins text-18 leading-7">{data.subheading}</h3>}
      </div>
      <div id={formDivId} className="container" ref={formRef} />
    </div>
  );
};

export default HubspotFormTastic;
